export default __webpack_public_path__ + "static/media/grafema_angura_13.3552444f.jpg";